import { friendInviteNotification, } from './friendInvite.js';
import { gameAbandonedNotification, } from './gameAbandoned.js';
import { gameInviteNotification, } from './gameInvite.js';
import { gameInviteReminderNotification, } from './gameInviteReminder.js';
import { gameStartReminderNotification, } from './gameStartReminder.js';
import { newGameNotification } from './newGame.js';
import { testNotification } from './test.js';
import { turnReadyNotification } from './turnReady.js';
export function getNotificationConfig(notification) {
    return getNotificationConfigByType(notification.type);
}
export function getNotificationConfigByType(type) {
    switch (type) {
        case 'game-invite':
            return gameInviteNotification;
        case 'game-invite-reminder':
            return gameInviteReminderNotification;
        case 'game-start-reminder':
            return gameStartReminderNotification;
        case 'friend-invite':
            return friendInviteNotification;
        case 'turn-ready':
            return turnReadyNotification;
        case 'new-game':
            return newGameNotification;
        case 'game-abandoned':
            return gameAbandonedNotification;
        case 'test':
            return testNotification;
        default:
            throw new Error(`Unknown notification type: ${type}`);
    }
}
export const notificationTypes = [
    'game-invite',
    'game-invite-reminder',
    'game-start-reminder',
    'friend-invite',
    'turn-ready',
    'new-game',
    'game-abandoned',
];
export * from './turnReady.js';
export * from './types.js';
//# sourceMappingURL=index.js.map